import { ENDPOINTS } from '../endpoints';
import { CustomResponseEntity } from '../types/common';
import { OrganizationDetailsDto } from '../types/dtos/organization/OrganizationDetailsDto';
import { api } from '../client/axiosClient';

export class OrganizationDetailsService {
  async getDetails(organizationId: string): Promise<CustomResponseEntity<OrganizationDetailsDto>> {
    return api.get(ENDPOINTS.organizations.details(organizationId));
  }
}

export const organizationDetailsService = new OrganizationDetailsService(); 